import Reviews from './Reviews.vue'

export default Reviews
